import type { TabItem } from '@/components/custom/erp';
import type { FormDialogModel } from './hooks';
import { BasicInfoTab } from './BasicInfoTab';
import InfoDropdown from './InfoDropdown';

export const FormHeader = (dialog: FormDialogModel): TabItem[] => [
  {
    id: 'info',
    label: 'Thông tin',
    component: (
      <div>
        <BasicInfoTab formMode={dialog.formMode} formState={dialog.formState} />
      </div>
    )
  }
];

export const FormHeaderActions = ({ dialog }: { dialog: FormDialogModel }) =>
  dialog.formMode !== 'add' && dialog.initialData?.uuid ? (
    <InfoDropdown uuid={dialog.initialData.uuid} ma_ct={dialog.initialData?.chung_tu} />
  ) : null;
